import { isEqual } from "lodash-es";

import { Module } from "src/api/modulesApi";
import { WorkspaceConfig } from "src/clients/flow-api";

export const MODEL_USAGE_FIELD_LABELS = {
  model_usage_tier: "Model tier",
  model_usage_monthly_cost_limit: "Monthly cost limit",
  model_usage_custom_overrides: "Custom overrides",
  model_usage_feature_overrides: "Feature overrides",
} as const;

export type ModelUsageDriftField = keyof typeof MODEL_USAGE_FIELD_LABELS;

export type ModelUsageDrift = {
  hasDrift: boolean;
  fields: ModelUsageDriftField[];
};

export const NO_DRIFT: ModelUsageDrift = { hasDrift: false, fields: [] };

const DEFAULTS: Record<ModelUsageDriftField, unknown> = {
  model_usage_tier: "default",
  model_usage_monthly_cost_limit: -1,
  model_usage_custom_overrides: {},
  model_usage_feature_overrides: {},
};

export const computeModelUsageDrift = (
  workspaceConfig: WorkspaceConfig | Record<string, unknown> | undefined,
  agentsModule: Module | undefined,
): ModelUsageDrift => {
  const agentsConfig = agentsModule?.desiredSpec.config as
    | Record<string, unknown>
    | undefined;
  if (!agentsConfig) return NO_DRIFT;
  const ws = (workspaceConfig ?? {}) as Record<string, unknown>;
  const fields = (Object.keys(DEFAULTS) as ModelUsageDriftField[]).filter(
    (k) => !isEqual(ws[k], agentsConfig[k]),
  );
  return { hasDrift: fields.length > 0, fields };
};
